import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import ptBr from '@fullcalendar/core/locales/pt-br';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getReservas, createReserva, deleteReserva } from '../api';
import EventModal from './EventModal';

export default function Calendar() {
  const [events, setEvents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState(null);
  const [hoveredEventId, setHoveredEventId] = useState(null);

  const carregarReservas = async () => {
    const res = await getReservas();
    setEvents(res.data.map(r => ({
      id: r.id,
      title: r.nome,
      start: r.inicio,
      end: r.fim,
    })));
  };

  useEffect(() => {
    carregarReservas();
  }, []);

  const handleDateSelect = (selectInfo) => {
    setSelectedRange(selectInfo);
    setIsModalOpen(true);
  };

  const abrirNovaReserva = () => {
    setSelectedRange(null); // o modal usa a data de hoje por padrão
    setIsModalOpen(true);
  };

  const handleEventSubmit = async (eventData) => {
    await createReserva(eventData);
    await carregarReservas();
    setIsModalOpen(false);
  };

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;

    const handleDelete = async (e) => {
      e.stopPropagation();
      if (!window.confirm(`Excluir a reserva de ${event.title}?`)) return;
      await deleteReserva(event.id);
      carregarReservas();
    };

    const hhmm = (d) => d
      ? new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', hour12: false })
      : '';
    const start = hhmm(event.start);
    const end = hhmm(event.end);
    // Texto completo para o tooltip (aparece ao passar o mouse na célula estreita).
    const full = `${start}${end ? '–' + end : ''} · ${event.title}`;

    return (
      <div
        className="event-pill"
        title={full}
        onMouseEnter={() => setHoveredEventId(event.id)}
        onMouseLeave={() => setHoveredEventId(null)}
      >
        <span className="event-pill__text">
          {start && <span className="event-pill__time">{start}</span>}
          {event.title}
        </span>
        {hoveredEventId === event.id && (
          <span className="event-pill__del" onClick={handleDelete} title="Excluir" role="button">
            &times;
          </span>
        )}
      </div>
    );
  };

  return (
    <>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{ left: 'prev,next today', center: 'title', right: 'novaReserva' }}
        customButtons={{
          novaReserva: { text: 'Nova reserva', click: abrirNovaReserva },
        }}
        selectable={true}
        select={handleDateSelect}
        events={events}
        locales={[ptBr]}
        locale="pt-br"
        height="auto"
        eventContent={renderEventContent}
      />
      <EventModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleEventSubmit}
        range={selectedRange}
      />
    </>
  );
}
